import axios from 'axios';

import { API, DOMAIN } from '@autopass-web/domain';
import { getDpassSignupRecord } from '@autopass-web/feature-dpass-signup';

import type { Parkinglot, PaymentMethodType } from '@autopass-web/types';

// 非 times && 允許的廠商, partner_id 白名單先 hardcode 在前端
export const ALLOW_DPASS_SIGNUP_PARTNER_IDS: string[] = [
  '000c13f0-c5d9-4626-9164-dfb12604df83',
  '042d4b14-2487-4258-9dbc-142dfe4ea425',
  '0ad63780-f962-413b-8e92-77f63f18fdae',
  '9ba3bba4-6dcd-43be-9da8-6328223f2015',
  'a0f21851-c23c-4756-af19-3bc7b7a56f8e',
  'a39a6e7a-05d1-4657-b945-5e98be0eb0fc',
  'abefe7d2-f93c-4353-b455-3c6c1d7cf1a1',
  'bb836701-c5d6-44e8-9ec5-a7167f4ccec8',
  'bd101874-41fc-48f6-b586-298b8fa4e3b3',
  'dca05d82-50df-4ca9-b0c4-31ecc645e237',
];

const ALLOW_DPASS_SIGNUP_PARTNER_IDS_DEV: string[] = [
  'dee5051e-4b50-4054-b3a8-9ced884cd946',
];

export const DPASS_SIGNUP_FROM = 'guest_aps_parking';

const DPASS_API_CONFIG = DOMAIN.API_URL[API.DPASS];

export const dpassAxiosInstance = axios.create({
  baseURL: DPASS_API_CONFIG.baseUrl,
  timeout: 60 * 1000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const isDpassSignupVisible = ({
  parkinglot,
  paymentMethod,
}: {
  parkinglot: Parkinglot | null;
  paymentMethod: PaymentMethodType | null;
}) => {
  if (!parkinglot) return false;

  const isDev = process.env.NODE_ENV === 'development';
  const isAllowedPartnerProd = ALLOW_DPASS_SIGNUP_PARTNER_IDS.includes(
    parkinglot.partner_id,
  );
  const isAllowedPartnerDev = ALLOW_DPASS_SIGNUP_PARTNER_IDS_DEV.includes(
    parkinglot.partner_id,
  );
  const isAllowedPartner = isDev ? isAllowedPartnerDev : isAllowedPartnerProd;

  // Apple Pay 的 payment sheet 啟動後無法插入額外的同意步驟, 所以這類付款不顯示 DPass 註冊
  const supportsInlineConsent = paymentMethod !== 'apple_pay';

  return isAllowedPartner && supportsInlineConsent && !getDpassSignupRecord();
};
